module.exports = __webpack_public_path__ + "static/media/trash.3d70983c.svg";